export type ConnectorStyle = 'curved' | 'orthogonal';

const KEY = 'gantt:connectorStyle';

/** Préférence d'affichage personnelle (comme les largeurs de colonnes) — pas de synchronisation entre onglets/sessions nécessaire. */
export function loadConnectorStyle(): ConnectorStyle {
  try {
    return localStorage.getItem(KEY) === 'orthogonal' ? 'orthogonal' : 'curved';
  } catch {
    return 'curved';
  }
}

export function saveConnectorStyle(style: ConnectorStyle): void {
  try {
    localStorage.setItem(KEY, style);
  } catch {
    // stockage indisponible : la préférence reste simplement non persistée pour cette session.
  }
}
